import {onMounted, ref} from 'vue';
import {fetchUnderlingList, fetchDistrict, fetchTargetRegionV2, fetchCountryList} from '@/apis/common';
import {getOptions} from '@/apis/analysis';
import {useDataStore} from '@/stores/underList';

export const useUnderlingAndDistrictCN = () => {
    const underListStore = useDataStore();
    const fetchUnderList = async () => {
        try {
            const response = await fetchUnderlingList();
            if (response.errno === 0) {
                const newUnderList = (response.data || []).map((item: any) => ({
                    value: item.user_id,
                    label: item.real_name
                }));
                underListStore.setUnderList(newUnderList);
            }
        } catch (error) {
            console.error('Error fetching under list:', error);
        }
    };

    const fetchOrgList = async () => {
        try {
            const response = await getOptions({org_level: 1});
            if (response.errno === 0) {
                const newOrgList = response.data.list;
                underListStore.setOrgListData(newOrgList);
            }
        } catch (error) {
            console.error('Error fetching org list:', error);
        }
    };
    const fetchTarget = (data: any) => {
        const newArray = data.map((parent: any) => {
            const newParent = {
                ...parent,
                label: parent.region_name,
                value: parent.region_id,
                children: parent.country_list.map((child: any) => ({
                    ...child,
                    label: child.country_name,
                    value: child.country_id
                }))
            };
            return newParent;
        });
        return newArray;
    };
    const fetchTargetRegion = async () => {
        try {
            const response = await fetchTargetRegionV2();
            if (response.errno === 0) {
                const newTarget = fetchTarget(response.data);
                underListStore.setTargetRegionData(newTarget);
                return newTarget;
            }
        } catch (error) {
            console.error('Error fetching org list:', error);
        }
    };
    // 获取国家列表
    const fetchCountry = async () => {
        try {
            const response = await fetchCountryList();
            if (response.errno === 0) {
                // 过滤掉253,254,255
                const CountryList = response.data.country_list?.filter((item:any)=>item.country_id!==252&&item.country_id!==253&&item.country_id!==254&&item.country_id!==255)
                const newCountryList =CountryList.map((item: any) => {
                    return {
                        value: item.country_id,
                        label: item.country_name,
                        district_id: item.country_id,
                        district_name: item.country_name,
                        children:[]
                    };
                });
                underListStore.setCountryList(newCountryList);
                // 跟新之后的值
                return newCountryList;
            }
        } catch (error) {
            console.error('Error fetching org list:', error);
        }
    };

    // onMounted(() => {
    //     if (underListStore.getUnderList.length === 0) {
    //         // fetchUnderList();
    //     }

    //     if (underListStore.getOrgListData.length === 0) {
    //         // fetchOrgList();
    //     }
    // //     if (underListStore.getTargetRegionData.length === 0) {
    // //         fetchTargetRegion();
    // //     }
    // //     if (underListStore.getCountryList.length === 0) {
    // //         fetchCountry();
    // //     }
    // });

    return {
        fetchUnderList,
        fetchOrgList,
        fetchTargetRegion,
        fetchCountry
    };
};
